// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import React from 'react';

export function useControllableState<T>({
  prop,
  defaultProp,
  onChange = () => {},
}: {
  prop?: T | undefined;
  defaultProp?: T | undefined;
  onChange?: (state: T) => void;
}) {
  const [uncontrolledState, setUncontrolledState] = React.useState<
    T | undefined
  >(defaultProp);
  const isControlled = prop !== undefined;
  const value = isControlled ? prop : uncontrolledState;

  const setValue = React.useCallback(
    (nextValue: T | ((prev: T | undefined) => T)) => {
      if (isControlled) {
        const resolvedValue =
          typeof nextValue === 'function'
            ? (nextValue as (prev: T | undefined) => T)(prop)
            : nextValue;
        if (resolvedValue !== prop) onChange(resolvedValue as T);
      } else {
        setUncontrolledState(nextValue);
        if (typeof nextValue === 'function') {
          const resolvedValue = (nextValue as (prev: T | undefined) => T)(
            uncontrolledState
          );
          onChange(resolvedValue as T);
        } else {
          onChange(nextValue as T);
        }
      }
    },
    [isControlled, prop, onChange, uncontrolledState]
  );

  return [value, setValue] as const;
}
